module.exports = __webpack_public_path__ + "img/edit_scenes.ad5acf4.png";